import React from 'react';
//redux
import { Col, Modal, ModalBody, Row, Button, Form, Label } from 'reactstrap';
import {
  convertEventSelectToTarget,
  SelectInput,
} from '../../../../../../../components/selectInputComponent';

// Yup Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { Currency } from '../../../../../../../components/currencyInput';
import { createData } from '../../../../../../../utils/createData';

export const ModalService = ({
  item,
  handleDeleteServices,
  getValueOfService,
  isVisible,
  toggle,
  handleSubmit,
  servicesData,
}) => {
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      service: item
        ? {
            value: item.id,
            label: item.name,
          }
        : {},
      price: item ? item.price : '',
    },
    validationSchema: Yup.object({
      service: Yup.object().required('Nome é obrigatório'),
      price: Yup.string().required('Preço é obrigatório'),
    }),
    onSubmit: (values) => {
      const valuesToSubmit = {
        name: values.service.label,
        id: values.service.value,
        price: values.price,
      };
      handleSubmit(valuesToSubmit);
      toggle();
      validation.resetForm();
    },
  });

  return (
    <Modal
      isOpen={isVisible}
      toggle={() => {
        toggle();
      }}
      centered
      className="modal-md"
    >
      <Col className="modal-content border-0">
        <Col className="modal-header p-3 bg-soft-info">
          <span className="fs-14 fw-semibold">
            {item ? 'Editar serviço' : 'Novo serviço'}
          </span>
          <Button
            onClick={() => {
              toggle();
            }}
            className="btn-close"
          />
        </Col>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit(e);
          }}
        >
          <ModalBody className="modal-body mb-3">
            <Row className="g-3">
              <Col className="mb-2">
                <Label>Serviço</Label>
                <SelectInput
                  className="form-control bg-light border-0"
                  value={validation.values.service}
                  onChange={(e) => {
                    const price = getValueOfService(e.value);

                    validation.handleChange(
                      convertEventSelectToTarget('service', e)
                    );
                    validation.handleChange(
                      convertEventSelectToTarget('price', price)
                    );
                  }}
                  id="service"
                  options={createData(servicesData)}
                  invalid={
                    !!(
                      validation.touched.sellerInput &&
                      validation.errors.sellerInput
                    )
                  }
                />
              </Col>
              <Col>
                <Label>Preço</Label>
                <Currency
                  className="form-control bg-light border-0 text-align-right float-end text-end"
                  id="price"
                  value={validation.values.price}
                  onChange={(_, value) => {
                    validation.handleChange(
                      convertEventSelectToTarget('price', value)
                    );
                  }}
                />
              </Col>
            </Row>
          </ModalBody>
          <Row className="modal-footer">
            {item && (
              <Col className="hstack gap-2">
                <Button
                  type="button"
                  onClick={() => {
                    handleDeleteServices();
                    toggle();
                  }}
                  className="btn-danger"
                >
                  Excluir
                </Button>
              </Col>
            )}
            <Col className="hstack gap-2 justify-content-end">
              <button
                type="button"
                onClick={() => {
                  toggle();
                }}
                className="btn btn-link"
              >
                Cancelar
              </button>
              <Button type="submit" className="btn btn-primary" id="add-btn">
                {item ? 'Editar' : 'Adicionar'}
              </Button>
            </Col>
          </Row>
        </Form>
      </Col>
    </Modal>
  );
};
